import { render, staticRenderFns } from "./QuestionDialog.vue?vue&type=template&id=128a68fe&scoped=true"
import script from "./QuestionDialog.vue?vue&type=script&lang=js"
export * from "./QuestionDialog.vue?vue&type=script&lang=js"
import style0 from "./QuestionDialog.vue?vue&type=style&index=0&id=128a68fe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128a68fe",
  null
  
)

export default component.exports